<template>
    <div class="panel bgPanel mt1x pb1x emptyToken_EE h21x">
        <div class="title title-bg">
            <span :title="getLanguageStr('word1746','发电实时')">{{getLanguageStr("word1746","发电实时")}}</span>
            <!-- <a class="fR fs08x" v-if="stationInfo.gridInterconnectionType=='EXCESS'" @click="$emit('realData')">{{$t('',['点击查看详情'])}}</a> -->
        </div>
        <loading v-show="isLoading"></loading>
        <div v-show="JSON.stringify(stationInfo) !='{}'" class="pl2x pr2x">
            <div class="bdSub-bottom dpIB_E vaT_E pb1x">
                <div class="taC mr1x pt1x">
                 <div class="icoSys h3x w3x"  :class="{bgPrimary:stationInfo.generationPower,bgLight:!stationInfo.generationPower}">
                    <svg :class="{fWhite:stationInfo.generationPower,fSub:!stationInfo.generationPower}">
                        <use v-if='type==="light"' xlink:href="#ico-getPower"></use>
                        <use v-else-if='type==="wind"' xlink:href="#plant-wind-o"></use>
                    </svg>
                </div>
                <span class="mt05x dpIB" :title="getLanguageStr('word559','发电')">{{getLanguageStr("word559","发电")}}</span>
                </div>
                <ul class="clearfix pl1x fL_E pr1x_E pt1x">
                    <li>
                        <div class="mb1x w7x" :title="$t('word176',['发电功率'])">{{$t("word176",["发电功率"])}}</div>
                        <div class="cMain">
                            <span :title="convertData(stationInfo.generationPower,2,'','W')[0]">
                                <span class="fs14x">{{convertData(stationInfo.generationPower,2,"","W")[1]}}</span>
                                {{convertData(stationInfo.generationPower,2,"","W")[2]}}
                            </span>
                        </div>
                    </li>
                    <li v-if="fromWhere!='child'">
                        <div class="mb1x w7x" :title="getLanguageStr('device_management78','当日满发小时')">{{getLanguageStr("device_management78","当日满发小时")}}</div>
                        <div :title="floatFix(stationInfo.fullPowerHoursDay,2,' h', false)">
                            <span class="fs14x">{{floatFix(stationInfo.fullPowerHoursDay,2, null, false)}}</span>
                            <span v-if="stationInfo.fullPowerHoursDay!=null">h</span>
                        </div>
                    </li>
                </ul>
                  <div v-if="fromWhere!='child'" class="fR taC mr2x">
                      <div class="tsSVG mt05x">
                       <Svgpie :isnull='(stationInfo.generationCapacity==null)?false:true' :percent="floatFix(stationInfo.generationCapacity*100,2,'',false)" :sizeWH="'w7x h7x'" :InlineBlock="true"/>
                      </div>
                      <div :title="getLanguageStr('plant_list8','功率归一化')" class="w7x pt3x">{{getLanguageStr("plant_list8","功率归一化")}}</div>
                  </div>
            </div>
            <div class="pt2x pb2x tableSys vaM_E">
                <div class="w40pct bdSub-right">
                    <div class="dpIB">
                        <div class="mb2x" :title="$t('word358',['当日发电量'])">{{$t("word358",["当日发电量"])}}</div>
                        <div class="cMain" :title="convertData(stationInfo.generationValue,2,'k','Wh')[0]">
                            <span class="fs16x">{{convertData(stationInfo.generationValue,2,"k","Wh")[1]}}</span>
                            {{convertData(stationInfo.generationValue,2,"k","Wh")[2]}}
                        </div>
                    </div>
                </div>
                <div class="pl3x lh13">
                    <div class="mb1x"><span class="mr2x" :title="$t('word359',['当月发电量'])">{{$t("word359",["当月发电量"])}}</span><span :title="convertData(stationInfo.generationMonth,2,'k','Wh')[0]">{{convertData(stationInfo.generationMonth,2,"k","Wh")[0]}}</span></div>
                    <div class="mb1x"><span class="mr2x" :title="$t('word360',['当年发电量'])">{{$t("word360",["当年发电量"])}}</span><span :title="convertData(stationInfo.generationYear,2,'k','Wh')[0]">{{convertData(stationInfo.generationYear,2,"k","Wh")[0]}}</span></div>
                    <div><span class="mr2x" :title="$t('word357',['累计发电量'])">{{$t("word357",["累计发电量"])}}</span><span :title="convertData(stationInfo.generationUploadTotalOffset,2,'k','Wh')[0]">{{convertData(stationInfo.generationUploadTotalOffset,2,"k","Wh")[0]}}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as equipmentApi from '@/api/maintain/plant/list'
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import Svgpie from '@/components/common/Svgpie.vue'
export default {
  name: 'GeneratePower',
  components: {Loading, Svgpie},
  props: {
    fromWhere: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'light'
    }
  },
  data () {
    return {
      isLoading: false,
      stationInfo: {
        generationCapacity: null
      }
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    convertData: lib.convertData,
    show (data) {
      this.isLoading = true
      if (data.stationInfo) {
        this.stationInfo = data.stationInfo
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      } else {
        if (data.level == 0) {
          this._getList(data.stationId)
        } else {
          this._getList(data.systemId)
        }
      }
    },
    _getList (id) {
      this.isLoading = true
      equipmentApi.StationInfo(id).then(res => {
        this.isLoading = false
        this.stationInfo = res
      }, error => {
        this.isLoading = false
        !_.isEmpty(error) && this.$notify(error)
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
.tsSVG .w5x{
  width:7em;
  height: 7em;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/GeneratePower.vue